import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NoteProps } from './Note.types';
import { Icon } from '../../../ui-library';
import { ICON_INFO_SLIM } from '../../../ui-library/components/Icon';

import './Note.css';

const Note: FC<NoteProps> = ({
    text,
    subText = undefined,
    showIcon = true,
}) => {
    const { t } = useTranslation();

    return (
        <section className="note-container">
            {showIcon && <Icon type={ICON_INFO_SLIM} size={24}/>}
            <div>
                <p>{t(text)}</p>
                {subText && <p>{t(subText)}</p>}
            </div>
        </section>
    );
};

export default Note;
